module.exports = __webpack_public_path__ + "img/scorecard-clubspecific-example.4804d1fd.png";